import React from "react";

import Button from "src/components/common/Button";

import styles from "./styles.module.scss";

export default ({ onYes, onNo }) => (
    <div className={styles.agentLenderNotice}>
        <div className={styles.body}>
            <div className={`${styles.section} ${styles.korean}`}>
                <div className={styles.paragraph}>
                    이 차입물량은 트루테크놀로지스(이하 트루)와 해외 대여자 간의
                    합의에 따라 광고되는 차입가능물량(이하 “Tru
                    Availability”)이며, 이 물량을 차입할 시 트루와 당사간의
                    계약에 따라{" "}
                    <span className={styles.strong}>거래수수료가 발생</span>
                    합니다.
                </div>
                <div className={styles.paragraph}>
                    이 차입물량은 한국증권금융 대차거래중개시스템(Ace+)에 의해{" "}
                    <span className={styles.strong}>경쟁의 방식</span>으로 체결
                    및 인도가 이루어집니다.
                </div>
                <div className={styles.paragraph}>
                    당사는 귀사의 지시에 따라{" "}
                    <span className={styles.strong}>
                        다음 영업일(T+1)에 Ace+에 경쟁거래 방식으로 차입 신청
                    </span>
                    을 하게 되며(“신청 대행"), 같은 날 Ace+에서 체결이 된 후
                    트루웹에 차입계약 내역이 생성됩니다.
                </div>
                <div className={styles.paragraph}>
                    이 물량에는 다음과 같은 제한이 따르며, 이에 동의하실 경우
                    "Yes" 버튼을 눌러주세요.
                    <ul>
                        <li>
                            주식이 인도되는 날부터 최소 3일간 상환이 가능하지
                            않습니다 (월요일에 인도가 될 경우 목요일부터 상환
                            가능).
                        </li>
                        <li>
                            상환을 하고자 하는 경우 상환 하루 전 16:00 까지
                            당사(트루테크놀로지스)로 통보되어야 합니다.
                        </li>
                        <li>
                            차입자가 일방적으로 차입 신청을 취소하는 경우, 일정
                            기간 대여가능물량(Availability) 정보에의 접근이
                            차단될 수 있습니다.
                        </li>
                        <li>
                            당사는 신청 대행 이후 발생하는 체결, 인도, 리콜에
                            대해 책임을 지지 않습니다.
                        </li>
                    </ul>
                </div>
            </div>

            <div className={styles.section}>
                <div className={styles.paragraph}>
                    Your selection contains availability from an offshore
                    lender, which is provided under an agreement between the
                    lender and Tru(‘Tru Availability’). By borrowing this
                    availability, you agree to pay a trading fee defined in the
                    subscription agreement between your company and Tru.
                </div>
                <div className={styles.paragraph}>
                    Tru will schedule a bid in KSFC’s bid-offer system(Ace+) on
                    your behalf, this will be updated to a confirmation once it
                    matches in KSFC on the next business day(T+1).
                </div>
                <div className={styles.paragraph}>
                    The loans have special conditions:
                    <ul>
                        <li>Minimum term of 3 days.</li>
                        <li>
                            Returns must be communicated to Tru before 4PM KST
                            on one business day prior to the desired return
                            date.
                        </li>
                        <li>
                            If a request is canceled, access to the availability
                            may be lost for a certain period of time.
                        </li>
                        <li>
                            Tru does not guarantee settlement of the borrows and
                            is not responsible for covering recalls.
                        </li>
                    </ul>
                </div>
                <div className={styles.paragraph}>
                    Please press "Yes" to confirm you understand and proceed.
                </div>
            </div>
        </div>

        <div className={styles.buttons}>
            <Button
                onClick={onYes}
                dataTestId="agree-with-agent-lender-flow"
                value="Yes"
            />
            <Button
                onClick={onNo}
                color="reversedWhite"
                dataTestId="cancel-agent-lender-flow"
                value="No"
            />
        </div>
    </div>
);
